import React from "react";
import "../styles/loader.scss";
const BouncingDotsLoader = (props) => {
  return (
    <>
      <div className="bouncing-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  );
};

export default BouncingDotsLoader;
